import styled from '@emotion/styled';

import { FirstOrder } from './parts/FirstOrder';
import { OrderQuantity } from './parts/OrderQuantity';
import { StoreDeal } from './parts/StoreDeal';

export const NoticeText = ({ children }: { children: React.ReactNode }) => {
  return <NoticeTextWrapper>{children}</NoticeTextWrapper>;
};

NoticeText.FirstOrder = FirstOrder;
NoticeText.OrderQuantity = OrderQuantity;
NoticeText.StoreDeal = StoreDeal;

const NoticeTextWrapper = styled.div`
  margin: 14px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
